import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface EditEmailForCandidateResponse extends BackendResponse {}
export interface EditEmailForCandidateParameters extends NextApiParams {
  emailFrom: string;
  emailTo: string;
}

export const editEmailForCandidate = withNextApi<
  EditEmailForCandidateResponse,
  EditEmailForCandidateParameters
>("/cvp/cvpstartemailchangeconfirmationprocess2");
